import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

export const MedicalIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => (
  <svg
    width={getColorIconSize(size)}
    height={getColorIconSize(size)}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 13L7 13.917C7.00017 16.7338 9.30426 18.9999 12.125 19C14.9429 19 17.245 16.7386 17.25 13.9258V13C17.25 12.4477 16.8023 12 16.25 12C15.6978 12.0002 15.25 12.4478 15.25 13V13.917C15.2498 15.6101 13.8605 17 12.125 17C10.3896 16.9999 9.00017 15.6101 9 13.917V13C9 12.4477 8.55228 12 8 12C7.44772 12 7 12.4477 7 13Z"
        fill="currentColor"
      />
      <path
        d="M14.5 6.45312L14.4912 6.79004C14.3174 10.2421 11.4852 13 8 13C4.40222 13 1.5 10.0607 1.5 6.45312V2.85449C1.50021 2.11957 2.09084 1.5 2.84961 1.5H5.75195V3.5H3.5V6.45312L3.50586 6.68848C3.62703 9.09734 5.6002 11 8 11C10.4773 11 12.5 8.9721 12.5 6.45312V3.5H10.248V1.5H13.1504C13.9074 1.5 14.5 2.11751 14.5 2.85449V6.45312Z"
        fill="currentColor"
      />
      <path
        d="M5.00019 3.5V1.5C5.00019 0.947715 5.4479 0.5 6.00019 0.5C6.55247 0.5 7.00019 0.947715 7.00019 1.5V3.5C7.00019 4.05228 6.55247 4.5 6.00019 4.5C5.4479 4.5 5.00019 4.05228 5.00019 3.5Z"
        fill="currentColor"
      />
      <path
        d="M9 3.5V1.5C9 0.947715 9.44772 0.5 10 0.5C10.5523 0.5 11 0.947715 11 1.5V3.5C11 4.05228 10.5523 4.5 10 4.5C9.44772 4.5 9 4.05228 9 3.5Z"
        fill="currentColor"
      />
      <path
        d="M16.5 15C17.8807 15 19 13.8807 19 12.5C19 11.1193 17.8807 10 16.5 10C15.1193 10 14 11.1193 14 12.5C14 13.8807 15.1193 15 16.5 15Z"
        fill="var(--cdl-chart-green-base)"
      />
    </svg>
  </svg>
);

export default MedicalIcon;
